import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ClientService } from '../services/client.service';
import { ScreeningService } from '../services/screening.service';
import { ApplicantDataService } from '../services/applicant-data.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-applicant-review-report',
  templateUrl: './applicant-review-report.component.html',
  styleUrls: ['./applicant-review-report.component.less']
})
export class ApplicantReviewReportComponent implements OnInit {

  constructor(public date : DatePipe,public location: Router, public activatedRoute: ActivatedRoute, public auth: AuthService, public clientSrv: ClientService, public screenings : ScreeningService, public applicantData : ApplicantDataService, public toast : ToastrService) {
    this.auth.titleBarText = "Report Summary"
  }

  gotoReport(){
    console.log('CHAAA')
    this.location.navigateByUrl(`/report/${this.applicantData.token}`)
  }

  ngOnInit() {
  }

}
